import "./PhotographySessions.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Details from "./sections/Details";
import Pricing from "./sections/Pricing";
import BookingCta from "./sections/BookingCta";
import YouTubeGallery from "./sections/YouTubeGallery";
import Footer from "@/reusable_sections/Footer";
export default function PhotographySessionsPage() {
  return <div>
      <Header />
      <Hero />
      <Details />
      <Pricing />
      <BookingCta />
      <YouTubeGallery />
      <Footer />
    </div>;
}